export const ReferringCustomerIdKey = 'referring_customer_id';

export const extractReferringCustomerId = (analytics: { [key: string]: string | undefined | null; qs: string }) => {
  if (localStorage.getItem(ReferringCustomerIdKey)) {
    return { ...analytics, [ReferringCustomerIdKey]: localStorage.getItem(ReferringCustomerIdKey) as string };
  }

  if (analytics?.qs) {
    try {
      const urlParams = new URLSearchParams(analytics.qs);
      const referringCustomerId = urlParams.get(ReferringCustomerIdKey);
      if (referringCustomerId) {
        localStorage.setItem(ReferringCustomerIdKey, referringCustomerId);
        return { ...analytics, [ReferringCustomerIdKey]: referringCustomerId };
      }
    } catch (e) {
      // No need to do anything if the qs is malformed or the referring_customer_id is not present
    }
  }

  return analytics;
};
